// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__hHAjr","col":"styles_col__1BWj4"};